export const inject = function(key, value, vue3app, options) {
  if (!key) {
    throw new Error("inject(key, value) has no key provided");
  }
  if (value === undefined) {
    throw new Error("inject(key, value) has no value provided");
  }

  key = "$" + key;
  // Check if plugin not already installed
  const installKey = "__development_panel_" + key + "_installed__";
  if (vue3app[installKey]) {
    return;
  }
  vue3app[installKey] = true;
  // Call Vue.use() to install the plugin into vm  
  vue3app.use(() => {
    if (!Object.prototype.hasOwnProperty.call(vue3app, key)) {
      Object.defineProperty(vue3app.config.globalProperties, key, {
        get() {
          return value;
        },
      });
    }
  }, options);
};

export const excutePlugins = async (plugins, { context, inject }, options) => {
  for (const key in plugins) {
    const plugin = plugins[key];
    if (typeof plugin === "function") {
      try {
                  
        //console.time(`\x1b[40m\x1b[31mplugin ${key}`);

        await plugin({ context, options }, inject(key, plugin, context, options));

        //console.timeEnd(`\x1b[40m\x1b[31mplugin ${key}`);
      } catch (error) {
        /*console.group(plugin.name);
        console.error(error);
        console.groupEnd(plugin.name);*/
      }
    }
  }
};